const UPDATE_SIMILAR = (state, payload) => {
  // console.log("UPDATE_SIMILAR");
  if (payload.length > 0) {
    state.similarProducts = [...state.similarProducts, ...payload]
  }
};
const UPDATE_EMBEDSIMILAR = (state, payload) => {
  // console.log("UPDATE_SIMILAR");
  if (payload.length > 0) {
    state.embedSimilarProducts = [...state.embedSimilarProducts, ...payload]
  }
};
const UPDATE_EMBEDRECENT = (state, payload) => {
  // console.log("UPDATE_SIMILAR");
  if (payload.length > 0) {
    state.embedRecentProducts = [...state.embedRecentProducts, ...payload]
  }
};
const UPDATE_RECENT = (state, payload) => {
  // console.log("UPDATE_RECENT");
  state.recentProducts = [...state.recentProducts, ...payload];
};
const UPDATE_PURCHASED = (state, payload) => {
  // console.log("UPDATE_RECENT");
  state.purchasedProducts = [...payload];
};
const UPDATE_CROSSSELL = (state, payload) => {
  // console.log("UPDATE_CROSSSELL");
  if (payload.length > 0) {
    state.crosssellProducts = [...state.crosssellProducts, ...payload]
  }
};
const RESET_SIMILAR = (state) => {
  // console.log("RESET_SIMILAR");
  state.similarProducts = [];
  state.similarProductsPage = 1;
};
const RESET_EMBEDSIMILAR = (state) => {
  // console.log("RESET_SIMILAR");
  state.embedSimilarProducts = [];
};
const RESET_EMBEDRECENT = (state) => {
  // console.log("RESET_SIMILAR");
  state.embedRecentProducts = [];
};
const RESET_CROSSSELL = (state) => {
  // console.log("RESET_SIMILAR");
  state.crosssellProducts = [];
  state.crosssellProductsPage = 1;
};
const RESET_RECENT = (state) => {
  // console.log("RESET_recent");
  state.recentProducts = [];
  state.recentProductsPage = 1;
};
const RESET_PURCHASED = (state) => {
  // console.log("RESET_recent");
  state.purchasedProducts = [];
  state.purchasedProducts = 1;
};
const UPDATE_PRODUCT_ID = (state, payload) => {
  // console.log("UPDATE_PRODUCT_ID");
  state.lastProductId = payload;
};
const UPDATE_UUID = (state, payload) => {
  // console.log("UPDATE_UUID")
  state.uuid = payload;

};
const UPDATE_C_PAGE = (state, payload) => {
  state.c_page = payload;
};
const UPDATE_LANG = (state, payload) => {

  if (payload) {
    state.lang = payload;
  } else {
    state.lang = 'en';

  }

};
const PRODUCTS_NEXT = function (state, payload) {
  // console.log("NEXT");
  let collectionPage = payload.collection + "ProductsPage";

  state[collectionPage] = state[collectionPage] + 1;

  this.dispatch("emitEvent", {
    data: {
      page: state.c_page,
      productid: "",
      sbAction: `Next`,
      site: state.client,
      source:
        payload.collection.charAt(0).toUpperCase() +
        payload.collection.slice(1),
      uuid: state.uuid,
    },
    headers: {},
    type: "sbaction",
  });
};
const PRODUCTS_PREV = function (state, payload) {
  // console.log("PRODUCTS_PREV");
  let collectionPage = payload.collection + "ProductsPage";
  state[collectionPage] =
    state[collectionPage] - 1 <= 1 ? 1 : state[collectionPage] - 1;

  this.dispatch("emitEvent", {
    data: {
      page: state.c_page,
      productid: "",
      sbAction: `Prev`,
      site: state.client,
      source:
        payload.collection.charAt(0).toUpperCase() +
        payload.collection.slice(1),
      uuid: state.uuid,
    },
    headers: {},
    type: "sbaction",
  });
};
const TOGGLE_LOADING = (state, payload) => {
  console.log("TOGGLE_LOADING", payload);
  // state.isLoading = true;
  state.isLoading = payload;
  state.nextLoaderMobile = payload;
};
const TOGGLE_INFINITE_LOAD = (state, payload) => {
  state.stopInfiniteLoad = payload;
};
const TOGGLE_PANEL = function (state, payload) {
  console.log("TOGGLE_PANEL", payload);
  // Check if payload contains name or force  parameters and default if it does not
  let stateHasChanged = false;
  let panelName =
    payload && payload.name ? payload.name.split("Open")[0] : "menu";
  let panelState =
    payload && payload.force ? payload.force : !state[`${panelName}Open`];
  // Change current panel size to the default size for the panel being opened
  let panelSize =
    payload && payload.name
      ? state[payload.name.split("Open")[0] + "ProductsSize"]
      : 3;
  state.currentPanelSize = panelSize;

  if (state[`${panelName}Open`] != panelState) {
    stateHasChanged = true;
  }

  // Toggle state of the panel
  state[`${panelName}Open`] = panelState;
  // Remove notification
  state[
    "notification" + panelName.charAt(0).toUpperCase() + panelName.slice(1)
  ] = false;

  // If the panel is set to open close all other panels
  if (panelState == true) {
    for (const panel of state.panelList) {
      if (panel !== `${panelName}Open`) {
        state[panel] = false;
        state[panel.split("Open"[0])] = [];
        state[panel.split("Open"[0]) + "Page"] = 1;
      }
    }
  }
  if (stateHasChanged && payload.toggle) {
    this.dispatch("emitEvent", {
      data: {
        page: state.c_page,
        productid: "",
        sbAction: `${panelState ? "Open" : "Close"}`,
        site: state.client,
        source: panelName.charAt(0).toUpperCase() + panelName.slice(1),
        uuid: state.uuid,
      },
      headers: {},
      type: "sbaction",
    });
  }
};
const CLOSE_PANEL = function (state, payload) {
  // console.log('close panel', payload, payload.ctacollection, payload.collection)
  let collection = payload.collection ? payload.collection : payload
  let panel = payload.ctacollection ? `${payload.ctacollection.split('P')[0].charAt(0).toUpperCase() + payload.ctacollection.split('P')[0].slice(1)}Cta` : payload.charAt(0).toUpperCase() + payload.slice(1)

  state[collection + "Open"] = false;

  this.dispatch("emitEvent", {
    data: {
      page: state.c_page,
      productid: "",
      sbAction: `Close`,
      site: state.client,
      source: panel,
      uuid: state.uuid,
    },
    headers: {},
    type: "sbaction",
  });


};
const CLOSE_PANEL_NO_EVENT = function (state, payload) {
  // console.log('close panel n e')
  state[payload + "Open"] = false;
};
const OPEN_PANEL = function (state, payload) {
  // console.log('open panel')
  state.menuOpen = false;
  state[payload + "Open"] = true;
  let panelSize = payload ? state[payload + "ProductsSize"] : 3;
  state.currentPanelSize = panelSize;
  this.dispatch("emitEvent", {
    data: {
      page: state.c_page,
      productid: "",
      sbAction: `Open`,
      site: state.client,
      source: payload.charAt(0).toUpperCase() + payload.slice(1),
      uuid: state.uuid,
    },
    headers: {},
    type: "sbaction",
  });
};
const RESIZE_PANEL = (state, payload) => {
  let panelSize = 0;

  let p_len = payload.length;
  let p_page = payload.page;
  let panel = payload.panel;
  let size = payload.size;

  if (p_len < 3 && p_page == 1 && state[panel + "Size"] <= p_len) {
    panelSize = p_len;
  }

  if (size) {
    panelSize = size;
  }
  if (panelSize > 0) {
    state.currentPanelSize = panelSize;
  }
};
const EXPAND_CURRENT_PANEL = (state) => {
  state.currentPanelSize = 3;
};
const CHECK_MOBILE = (state, payload) => {
  state.isMobile = payload;
};
const COMPLETE_TOUR = (state, collection) => {
  state[collection + "TourDone"] = true;
};
const RESET_TOUR = (state, collection) => {
  state[collection + "TourDone"] = false;
};
const RESET_C_PAGE = (state) => {
  state.c_page = null;
};
const SET_C_PAGE = (state, payload) => {
  state.c_page = payload;
};
const SET_CONTROL_GROUP = (state, payload) => {
  state.control_group = payload;
};
const SET_CONTROL_FLAG = (state, payload) => {
  state.control_flag = payload;
};
const SET_ENABLED = (state, payload) => {
  state[payload.widget + "Enabled"] = payload.value;
};
const SET_CURRENCY = (state, payload) => {
  if (payload) {
    state.currency = payload;
  } else {
    state.currency = "€";
  }
};
const SET_DECIMALCOMMA = (state, payload) => {
  if (payload) {
    state.decimalcomma = true
  } else {

    state.decimalcomma = false
  }
};
const SET_CURRENCY_CODE = (state, payload) => {
  state.currencyCode = payload;

};
const SET_CLIENT = (state, payload) => {
  state.client = payload;
  state.site = payload;
};
const SET_PRICER = (state, payload) => {
  const priceR = payload ? parseInt(payload) : 90;
  state.pricer = priceR;
};

const OPEN_CTA = function (state, payload) {

  state.ctaHeading = payload.heading || "";
  state.ctaSubheading = payload.subheading || "";
  state.ctaProducts = payload.products || null;
  state.ctaTimer = payload.timer || "5000";
  state.ctaOpen = true;
  state.ctaAction = payload.action || "Recent";
  state["notification" + state.ctaAction.split("toggle")[1]] = true;
  this.dispatch("emitEvent", {
    data: {
      page: state.c_page,
      productid: "",
      sbAction: `Display`,
      site: state.client,
      source: `${payload.action.split("toggle")[1]}Cta`,
      uuid: state.uuid,
    },
    headers: {},
    type: "sbaction",
  });
};

const CLOSE_CTA = function (state) {
  state.ctaOpen = false;
};
const SET_PORTRAIT = (state, payload) => {
  let portraitBool = payload == "true" || payload == true ? true : false;
  state.portraitview = portraitBool;
};
const SET_BANNER_DATA = (state, payload) => {
  // console.log(payload)
  state.productBannerData = payload
};
const SET_BRAND = (state, payload) => {
  state.brand = payload
};
export default {
  SET_BANNER_DATA,
  SET_BRAND,
  SET_PORTRAIT,
  SET_CURRENCY,
  SET_CURRENCY_CODE,
  SET_PRICER,
  SET_C_PAGE,
  SET_CLIENT,
  SET_ENABLED,
  SET_CONTROL_GROUP,
  SET_CONTROL_FLAG,
  UPDATE_UUID,
  UPDATE_LANG,
  UPDATE_C_PAGE,
  UPDATE_PRODUCT_ID,
  UPDATE_SIMILAR,
  UPDATE_EMBEDSIMILAR,
  UPDATE_EMBEDRECENT,
  UPDATE_CROSSSELL,
  UPDATE_RECENT,
  UPDATE_PURCHASED,
  RESET_SIMILAR,
  RESET_EMBEDSIMILAR,
  RESET_EMBEDRECENT,
  RESET_CROSSSELL,
  RESET_PURCHASED,
  RESET_RECENT,
  RESET_C_PAGE,
  RESET_TOUR,
  TOGGLE_PANEL,
  TOGGLE_LOADING,
  TOGGLE_INFINITE_LOAD,
  PRODUCTS_NEXT,
  PRODUCTS_PREV,
  OPEN_CTA,
  OPEN_PANEL,
  CLOSE_CTA,
  CLOSE_PANEL,
  CLOSE_PANEL_NO_EVENT,
  COMPLETE_TOUR,
  CHECK_MOBILE,
  RESIZE_PANEL,
  EXPAND_CURRENT_PANEL,
  SET_DECIMALCOMMA
};